import React from 'react';
import { ASSESSMENTS } from 'config/constants';

const styles = {
  letterStyle: {
    fontSize: '4em',
    lineHeight: '1em',
    fontWeight: 'bold',
    marginTop: '175px',
  },
};

function OSpanLetterFlashcard({ letter, resultsCallback }) {
  const delay = ASSESSMENTS.LETTER_FLASH_INTERVAL;
  setTimeout(resultsCallback, delay);

  return (
    <div className="d-flex align-items-center" style={styles.letterStyle}>
      {letter}
    </div>
  );
}

export default OSpanLetterFlashcard;
